import React, { Component } from 'react'
import { StencilProvider } from '@amzn/stencil-react-components/context'
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'

import { history } from './store'

import SecuredApp from './SecuredApp'
import CallbackV2 from './components/CallbackV2'
import LogoutV2 from './components/LogoutV2'
import OAuthCallbackV2 from './components/OAuthCallbackV2'
import ImpersonateV2 from './components/ImpersonateV2'
import MaintenanceV2 from './components/MaintenanceV2'

var appStartTime = Date.now()
export var appStartTime

class App extends Component {

  render() {
    return (
      <StencilProvider>
        <ConnectedRouter history={history}>
          <Switch>
            <Route path='/logout'>
              <LogoutV2/>
            </Route>
            <Route path='/callback'>
              <CallbackV2/>
            </Route>
            <Route path='/oauthcallback'>
              <OAuthCallbackV2/>
            </Route>
            <Route path='/impersonate'>
              <ImpersonateV2/>
            </Route>
            <Route path='/maintenance'>
              <MaintenanceV2/>
            </Route>
            <Route path='*'>
              <SecuredApp/>
            </Route>
          </Switch>
        </ConnectedRouter>
      </StencilProvider>
    )
  }
}

export default App
